import { redirect, type MiddlewareFunction } from 'react-router';
import {
  addPersistingQueryParamsToPath,
  ERROR_REDIRECT_EXCLUDE_PARAMS,
} from '../../helpers/urlHelper';
import {
  getOperations,
  loadRuntimeOperations,
} from '../../helpers/operationsHelper';

const createOperationValidationMiddleware = (
  notFoundPath = '/404/',
): MiddlewareFunction => {
  return async ({ params }) => {
    const { operation } = params;

    if (operation === 'followup') {
      throw redirect(
        addPersistingQueryParamsToPath(notFoundPath, {
          exclude: ERROR_REDIRECT_EXCLUDE_PARAMS,
        }),
      );
    }

    if (operation) {
      await loadRuntimeOperations();

      if (!getOperations().some((op) => op.name === operation)) {
        throw redirect(
          addPersistingQueryParamsToPath(notFoundPath, {
            exclude: ERROR_REDIRECT_EXCLUDE_PARAMS,
          }),
        );
      }
    }
  };
};

export default createOperationValidationMiddleware;
